import type { MentionComposeElement } from './useEmailMentionAssist';

export interface ComposeAssistOptions {
  spellcheck?: boolean;
  autocorrect?: string;
  autocapitalize?: string;
  autocomplete?: string;
}

const DEFAULT_COMPOSE_ASSIST: Required<ComposeAssistOptions> = {
  spellcheck: true,
  autocorrect: 'on',
  autocapitalize: 'sentences',
  autocomplete: 'off'
};

/** Enables browser/device writing assist on discussion and comment compose fields. */
export function configureComposeAssist(
  element: MentionComposeElement | null | undefined,
  options: ComposeAssistOptions = {}
): void {
  if (!element) return;
  const merged = { ...DEFAULT_COMPOSE_ASSIST, ...options };
  element.spellcheck = merged.spellcheck;
  element.setAttribute('autocorrect', merged.autocorrect);
  element.setAttribute('autocapitalize', merged.autocapitalize);
  element.setAttribute('autocomplete', merged.autocomplete);
}
